import { SVGProps } from 'react'
import dynamic from 'next/dynamic'

const LoaderIcon = dynamic(() => import('../../assets/loader.svg'));

interface Props extends SVGProps<SVGElement> {
  styles?: string
}

const cls = "flex flex-1 flex-col h-full flex-grow p-8 px-4 items-center justify-center"

export const Loader = ({ styles = null, stroke = '#484542', width = 44, height = 44 }: Props) => (
  <section className={styles || cls}>
    <div className="flex min-h-full justify-center">
      {/* @ts-ignore */}
      <LoaderIcon width={width} height={height} stroke={stroke} />
    </div>
  </section>
)

export default Loader
